module.exports = __webpack_public_path__ + "img/groupTheme.0fc94c1f.png";